import script from "./SchemaTable.vue?vue&type=script&setup=true&lang=js"
export * from "./SchemaTable.vue?vue&type=script&setup=true&lang=js"

import "./SchemaTable.vue?vue&type=style&index=0&id=03af372f&lang=css"

const __exports__ = script;

export default __exports__